import { htmlATexto } from './busqueda';

/**
 * Separa la cita de cabecera del cuerpo del mensaje.
 *
 * Las respuestas nuevas guardan la referencia en `mensaje.respuestaA`, fuera del
 * texto, pero los mensajes antiguos (y lo que se pegue desde otro sitio) llevan
 * la cita incrustada como <blockquote> inicial. Al editar o copiar interesa solo
 * lo que dice el mensaje, no aquello a lo que responde.
 *
 * Una cita en mitad del mensaje sí forma parte de lo dicho y se queda en el cuerpo.
 */
export const separarCita = (html) => {
    if (!html) return { cita: '', cuerpo: '' };

    const doc = new DOMParser().parseFromString(`<body>${html}</body>`, 'text/html');
    const cabecera = [];

    let nodo = doc.body.firstElementChild;
    while (nodo) {
        const siguiente = nodo.nextElementSibling;
        const esCita = nodo.tagName === 'BLOCKQUOTE';
        const esVacio = nodo.textContent.trim() === '';

        if (!esCita && !esVacio) break;
        if (esCita) {
            cabecera.push(nodo.outerHTML);
            nodo.remove();
        }
        nodo = siguiente;
    }

    return { cita: cabecera.join(''), cuerpo: doc.body.innerHTML };
};

/** Texto del mensaje listo para el portapapeles, sin la cita a la que responde. */
export const textoParaCopiar = (html) => htmlATexto(separarCita(html).cuerpo).trim();
